import React from 'react';
import PropTypes from 'prop-types';
import {Input, Label} from 'reactstrap';

const Checkbox = ({checked, label, onCheck, disabled, inline}) => {
    const id = `${label}${Math.random()}`;
    return (
        <div className={`custom-control custom-checkbox pointer ${inline ? 'inline ml-2' : ''}`}>
            <Input
                disabled={disabled}
                className={'custom-control-input pointer'}
                type='checkbox'
                onChange={onCheck}
                checked={checked}
                id={id}
            />
            <Label className='custom-control-label pointer' for={id}>{label}</Label>
        </div>
    );
};

Checkbox.propTypes = {
    onCheck: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    inline: PropTypes.bool,
};

Checkbox.defaultProps = {
    disabled: false,
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/common/Checkbox.js